"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
let ReopenPageConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.reopenPage = false;
    this.autoOpen = false;
    this.changeAutoOpen = _.debounce((data) => __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/openShopUrl`, {
        openShopUrl: data
      });
    }), 500);
    this.changeReopenPage = _.debounce((data) => __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/ReopenPages`, {
        reopenPages: data
      });
    }), 500);
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        const reopen_page = yield API.get(`api://base.local/storages/preference/ReopenPages`);
        this.reopenPage = reopen_page.data.value.reopenPages;
      } catch (e) {
        let reopen_pages = false;
        yield API.put(`api://base.local/storages/preference/ReopenPages`, {
          reopenPages: reopen_pages
        });
        this.reopenPage = reopen_pages;
      }
      try {
        const auto_open = yield API.get(`api://base.local/storages/preference/openShopUrl`);
        this.autoOpen = auto_open.data.value.openShopUrl;
      } catch (e) {
        let auto_open = false;
        yield API.put(`api://base.local/storages/preference/openShopUrl`, {
          openShopUrl: auto_open
        });
        this.autoOpen = auto_open;
      }
    });
  }
};
ReopenPageConfig = __decorateClass([
  Component({
    components: {}
  })
], ReopenPageConfig);
export {
  ReopenPageConfig as default
};
